module.exports = __webpack_public_path__ + "static/img/10.5dac124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/10.png
// module id = rhId
// module chunks = 0